import Application from '@ember/application';
import Namespace from '@ember/application/namespace';
import ENV from '../config/environment';
import Constants from './constants';
import camelCase from 'lodash.camelcase';
import snakeCase from 'lodash.snakecase';
import upperFirst from 'lodash.upperfirst';

export default {
  getDataLocation() {
    return ENV.dataLocation;
  },

  getCdpLocation() {
    return ENV.cdpLocation;
  },

  getToolName() {
    return ENV.toolname;
  },

  isNumeric(value) {
    return !(this.isNullOrWhiteSpace(value) || isNaN(value)); //$.isNumeric(value);
  },

  numericOrDefault(value, defaultValue) {
    return this.isNumeric(value) ? value : defaultValue;
  },

  isNullOrWhiteSpace(text) {
    return typeof text !== 'undefined' ? text === null || text.toString().match(/^\s*$/) !== null : true;
  },

  isObject(value) {
    return !Array.isArray(value) && typeof value === 'object' && value !== null;
  },

  getItemFromMapWithKey(map, key) {
    let item = map[key];
    item.key = key;
    return item;
  },

  isBoolean(value) {
    return value === true || value === false;
  },

  convertToBoolean(value) {
    const validBooleanValues = ['true', 'yes', 'y'];
    value = value.toLowerCase();
    return validBooleanValues.includes(value);
  },

  compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  },

  findInItem(key, item) {
    return key in item ? item[key] : null;
  },

  generateNamingMetadata(item) {
    item.appName = snakeCase(item.name);
    item.propertyName = camelCase(item.name);
    item.fileName = upperFirst(item.propertyName);
    if (!item.article) item.article = Constants.DEFAULTS.ARTICLE; // Default if not provided
  },

  getAppContainer() {
    const app = Namespace.NAMESPACES.find((namespace) => namespace instanceof Application);

    if (app && app.__container__) return app.__container__;
    else if (app && app.rootElement === '#ember-testing') return { isTesting: true };
    else return {};
  },

  getMilliValue(value) {
    return value * Math.pow(10, 3);
  },

  getValue(object, keys) {
    return keys.split('.').reduce((o, k) => (o || {})[k], object);
  },
};
